import React, { type FunctionComponent, Fragment } from 'react'
import { useCallbackConfigurations } from 'domains/connect/components/utils/callbackConfigurations.hooks'
import { ConfigurationLoadingWrapper } from 'domains/connect/components/ConfigurationLoadingWrapper'
import AppHeader from 'legacy/components/AppHeader'
import { CallbackTestingForm } from 'domains/connect/components/CallbackTestingForm'
import { useDashMessage } from 'intl/intl.hooks'

export const ConnectCallbackTesting: FunctionComponent = () => {
  const { callbackConfigurations, loading, error } = useCallbackConfigurations()
  const stagingConfiguration =
    callbackConfigurations && callbackConfigurations.find(c => (c.environment = 'staging'))
  const hasError = error || !stagingConfiguration
  const headerMessage = useDashMessage('connect.callback-testing.header')
  return (
    <Fragment>
      <AppHeader title={headerMessage} />
      <ConfigurationLoadingWrapper loading={loading} error={hasError}>
        <CallbackTestingForm stagingConfiguration={stagingConfiguration} />
      </ConfigurationLoadingWrapper>
    </Fragment>
  )
}
